import React__default from 'react';
import { Box, CircularProgress, Tooltip, IconButton } from '@mui/material';
import dayjs from 'dayjs';
import DefaultIcon from '../../../DefaultIcon/index.js';

function renderTitleCell(row) {
    return React__default.createElement(Box, { title: row.title }, row.title);
}
function renderLastRunCell(row) {
    var _a, _b;
    var lastRunDate = ((_a = row.lastRun) === null || _a === void 0 ? void 0 : _a.startDate) ? dayjs((_b = row.lastRun) === null || _b === void 0 ? void 0 : _b.startDate).format("L LTS") : "-";
    return React__default.createElement(Box, { title: lastRunDate }, lastRunDate);
}
function renderActionsCell(row, t, onRunScript, KIcon) {
    if (KIcon === void 0) { KIcon = DefaultIcon; }
    return (React__default.createElement(Box, { textAlign: "right" }, row.lastRun && !row.lastRun.endDate ? (React__default.createElement(CircularProgress, null)) : (React__default.createElement(Tooltip, { title: t("components.kf-script-manager.table.body.cell.actions.run.title") || "" },
        React__default.createElement(IconButton, { "aria-label": t("components.kf-script-manager.table.body.cell.actions.run.title") || "", onClick: function () {
                onRunScript(row);
            }, size: "large" },
            React__default.createElement(KIcon, { className: "fa-solid fa-play" }))))));
}

export { renderActionsCell, renderLastRunCell, renderTitleCell };
//# sourceMappingURL=utils.js.map
